import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import apiRoutes from "../api/apiRoutes";
import { apiDownload, apiGet } from "../api/request";

const BookDetails = () => {
  const [book, setBook] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const bookId = queryParams.get("id");

  useEffect(() => {
    const fetchBook = async () => {
      try {
        if (bookId) {
          const response = await apiGet(`${apiRoutes.getEBook(bookId)}`);
          if (response.responsedata) {
            setBook({
              title:
                response.responsedata.title || "Best Book for Product Designer",
              code: response.responsedata.code || "BK001",
              author: response.responsedata.author || "John Doe",
              language: response.responsedata.language?.name || "English",
              category: response.responsedata.category?.name || "Design",
              status: response.responsedata.status || "Published",
              mode: response.responsedata.mode || "Public",
              description:
                response.responsedata.description ||
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Euismod diam nec magnis potenti non fusce accumsan. Eu potenti nam nec.",
              coverImage:
                response.responsedata.cover_image ||
                "https://via.placeholder.com/300x450",
              bannerImage:
                response.responsedata.banner_image ||
                "https://via.placeholder.com/1200x200",
              pdfUrl: response.responsedata.pdf_url || "#",
            });
          }
        }
      } catch (error) {
        console.error("Error fetching book:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBook();
  }, [location.search]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Loading...
      </div>
    );
  }

  if (!book) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Book not found
      </div>
    );
  }

  const handleStartReading = () => {
    // Navigate to a reading page or trigger reading functionality
    navigate(`/view-book/${bookId}`);
  };

  const handleStartDownload = async () => {
    try {
      if (!bookId) return;

      const response = await apiDownload(apiRoutes.downloadEBook(bookId));

      const blob = new Blob([response.data], { type: "application/pdf" });
      const downloadUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = `${book?.title || "ebook"}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(downloadUrl);
    } catch (err) {
      console.error("Download error:", err);
      alert("PDF download failed");
    }
  };

  return (
    //     <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
    //       {/* Decorative Elements */}
    //       <div className="absolute top-20 left-1/4 w-3 h-3 bg-teal-500 rounded-full"></div>
    //       <div className="absolute top-40 left-1/3 w-3 h-3 bg-orange-500 rounded-full"></div>
    //       <div className="absolute bottom-20 right-10 w-3 h-3 bg-teal-500 rounded-full"></div>
    //       <div className="absolute bottom-40 right-20 w-3 h-3 bg-orange-500 rounded-full"></div>
    //       <div className="absolute bottom-10 right-40 w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center">
    //         <span className="text-teal-600 text-2xl">📖</span>
    //       </div>

    //       <div className="max-w-6xl w-full flex flex-col lg:flex-row items-center gap-12">
    //         {/* Left Section: Text and Buttons */}
    //         <div className="lg:w-1/2 space-y-6">
    //           <h1 className="text-4xl font-bold text-gray-900 leading-tight">
    //             {book.title}
    //           </h1>
    //           <p className="text-sm text-gray-600">
    //             {book.description}
    //           </p>

    //      <div className="flex items-center justify-center space-x-2 bg-white shadow-md rounded-full px-6 py-2 w-fit">
    //   <span className="text-md text-blue-500 flex items-center">📘</span>
    //   <p className="text-base text-xs text-gray-700 flex items-center m-0">
    //     {book.category}
    //   </p>
    // </div>

    //           <div className="flex space-x-4">
    //             <a
    //               href={book.pdfUrl}
    //               download
    //               className="bg-teal-500 text-white px-8 py-3 rounded-md font-semibold text-md hover:bg-teal-600 transition-all"
    //             >
    //               Download as PDF
    //             </a>
    //             <button
    //               onClick={handleStartReading}
    //               className="border-2 border-gray-900 text-gray-900 px-8 py-3 rounded-md font-semibold text-md hover:bg-gray-900 hover:text-white transition-all"
    //             >
    //               Read Now
    //             </button>
    //           </div>

    //         </div>

    //         {/* Right Section: Book Mockup */}
    //         <div className="lg:w-1/2 flex justify-center">
    //           <div className="relative">
    //             <img
    //               src={book.coverImage}
    //               alt="Book Cover"
    //               className="w-80 h-[450px] object-cover rounded-lg shadow-2xl transform hover:scale-105 transition-transform duration-300"
    //             />
    //             <div className="absolute -top-4 -left-4 w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center">
    //               <span className="text-orange-600 text-2xl">📘</span>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-20 left-1/4 w-3 h-3 bg-teal-500 rounded-full"></div>
      <div className="absolute top-40 left-1/3 w-3 h-3 bg-orange-500 rounded-full"></div>
      <div className="absolute bottom-20 right-10 w-3 h-3 bg-teal-500 rounded-full"></div>
      <div className="absolute bottom-40 right-20 w-3 h-3 bg-orange-500 rounded-full"></div>
      <div className="absolute bottom-10 right-40 w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center">
        <span className="text-teal-600 text-2xl">📖</span>
      </div>

      <div className="max-w-6xl w-full flex flex-col lg:flex-row items-center gap-12">
        {/* Left Section: Text and Buttons */}
        <div className="lg:w-1/2 space-y-6">
          <h1 className="text-4xl font-bold text-gray-900 leading-tight">
            {book.title}
          </h1>
          {/* Category Tag */}
          <div className="flex items-center justify-center space-x-2 bg-gray-100 rounded-md px-2 py-2 w-fit">
            <span className="text-md text-blue-500 flex items-center">📘</span>
            <p className="text-xs font-semibold text-gray-700 flex items-center m-0">
              {book.category}
            </p>
          </div>
          <p className="text-sm text-gray-600">{book.description}</p>

          {/* Additional Details */}
          <div className="flex flex-wrap gap-4 mt-4 text-sm text-gray-700">
            <div className="text-xs px-2 py-2 rounded-md  border">
              <span className="font-semibold">Author:</span> {book.author}
            </div>
            <div className="text-xs px-2 py-2 rounded-md  border">
              <span className="font-semibold">Status:</span> {book.status}
            </div>
            <div className="text-xs px-2 py-2 rounded-md  border">
              <span className="font-semibold">Mode:</span> {book.mode}
            </div>
            <div className="text-xs px-2 py-2 rounded-md border">
              <span className="font-semibold">Language:</span> {book.language}
            </div>
          </div>

          {/* Buttons */}
          <div className="flex space-x-4">
            <button
              onClick={handleStartDownload}
              download
              className="bg-black flex items-center justify-center text-white px-4 py-3  rounded-md font-regular text-md hover:bg-yellow-600 transition-all"
            >
              Download as PDF
            </button>
            <button
              onClick={handleStartReading}
              className="border-2 border-gray-900 text-gray-900 px-6 py-3 rounded-md font-semibold text-md hover:bg-gray-900 hover:text-white transition-all"
            >
              Read Now
            </button>
          </div>
        </div>

        {/* Right Section: Book Mockup */}
        <div className="lg:w-1/2 flex justify-center">
          <div className="relative">
            <img
              src={
                "https://mvdebook.blr1.digitaloceanspaces.com/media/" +
                book.coverImage
              }
              alt="Book Cover"
              className="w-80 h-[450px] object-cover rounded-lg shadow-2xl transform hover:scale-105 transition-transform duration-300"
            />
            <div className="absolute -top-4 -left-4 w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center">
              <span className="text-orange-600 text-2xl">📘</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookDetails;
